import { Card } from "@/shared/ui/card";
import { Skeleton } from "@/shared/ui/skeleton";

export const InvestorCardSkeleton = () => {
  return (
    <Card className="bg-card border-border p-6">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-4 flex-1">
          <Skeleton className="w-12 h-12 rounded-full" />
          
          <div className="flex-1">
            <Skeleton className="h-5 w-48 mb-2" />
            <Skeleton className="h-4 w-64" />
          </div>
        </div>

        <div className="flex flex-wrap items-center gap-x-8 gap-y-3">
          <div>
            <Skeleton className="h-3 w-20 mb-1" />
            <Skeleton className="h-6 w-20 rounded-full" />
          </div>
          
          <div>
            <Skeleton className="h-3 w-12 mb-1" />
            <Skeleton className="h-6 w-16 rounded-full" />
          </div>

          <div>
            <Skeleton className="h-9 w-24 rounded-md" />
          </div>
        </div>
      </div>
    </Card>
  );
};

